import React from 'react';
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import KnowledgePreviewCell from './KnowledgePreviewCell';

const RELEVANCE_HINT =
  'Relevance is populated by semantic search, which is not part of this release.';

const KnowledgeTable = ({ rows, hasActiveFilters, sortBy, sortDir, isTablet, onSort, tableTopRef }) => (
  <>
    <Box ref={tableTopRef} />
    <TableContainer
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
        overflowX: 'auto',
      }}
    >
      <Table sx={{ minWidth: isTablet ? 720 : undefined }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, color: 'text.secondary' }}>
              <TableSortLabel
                active={sortBy === 'topic'}
                direction={sortBy === 'topic' ? sortDir : 'asc'}
                onClick={() => onSort('topic')}
              >
                Topic
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ fontWeight: 700, color: 'text.secondary' }}>
              <TableSortLabel
                active={sortBy === 'source'}
                direction={sortBy === 'source' ? sortDir : 'asc'}
                onClick={() => onSort('source')}
              >
                Source
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ fontWeight: 700, color: 'text.secondary' }}>Preview</TableCell>
            <TableCell sx={{ fontWeight: 700, color: 'text.secondary', whiteSpace: 'nowrap' }}>
              Evidence
            </TableCell>
            <TableCell sx={{ fontWeight: 700, color: 'text.secondary', whiteSpace: 'nowrap' }}>
              <Box display='inline-flex' alignItems='center' gap={0.5}>
                Relevance
                <Tooltip title={RELEVANCE_HINT}>
                  <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled', cursor: 'help' }} />
                </Tooltip>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align='center' sx={{ py: 6, color: 'text.secondary' }}>
                {hasActiveFilters
                  ? 'No knowledge chunks match your current filters.'
                  : 'No knowledge chunks available for this client yet.'}
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell sx={{ fontWeight: 700, verticalAlign: 'top', width: '18%' }}>
                  {row.topic}
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: 'top',
                    color: 'text.secondary',
                    width: '18%',
                    wordBreak: 'break-word',
                  }}
                >
                  {row.source}
                </TableCell>
                <KnowledgePreviewCell text={row.text} />
                <TableCell sx={{ verticalAlign: 'top', width: '16%' }}>
                  {row.evidence?.length ? (
                    <Box display='flex' flexWrap='wrap' gap={0.5}>
                      {row.evidence.map((label, index) => (
                        <Chip
                          key={`${row.id}-${label}-${index}`}
                          label={label}
                          size='small'
                          variant='outlined'
                          sx={{ fontSize: 12 }}
                        />
                      ))}
                    </Box>
                  ) : (
                    <Typography variant='caption' color='text.disabled'>
                      —
                    </Typography>
                  )}
                </TableCell>
                <TableCell sx={{ verticalAlign: 'top', whiteSpace: 'nowrap', width: '10%' }}>
                  <Tooltip title={RELEVANCE_HINT}>
                    <Typography component='span' color='text.disabled'>
                      —
                    </Typography>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </>
);

export default KnowledgeTable;
